
































import {Vue, Component} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import Card from '@/components/material/Card.vue';
import DlgSubscriptionsDelete from '@/modules/user/subscriptions/_components/DlgSubscriptionsDelete.vue';

@Component({
  components: {DlgSubscriptionsDelete, Card},
})
export default class Settings extends Vue {
  private loading: boolean = false;
  private headers: any = [
    {
      text: 'Animal',
      align: 'left',
      value: 'title',
    },
    {
      text: 'Subscription active since',
      align: 'left',
      value: 'entry_date',
    },
    {
      text: 'Status',
      align: 'left',
      value: 'status',
    },
    {
      text: '',
      align: 'left',
      sortable: false,
      value: '',
    },
  ];

  @Getter('user/subscriptions/all') private subscriptions!: any;

  @Action('user/subscriptions/read') private readSubscriptions!: any;

  private async created() {
    this.loading = true;
    await this.readSubscriptions();
    this.loading = false;
  }

  // private stopSubscription(subscription: any) {
  // }
}
